export default function SideBarIcon({className, name, src, ...props}) {

    return (
        <div className={`w-[2.038rem] h-[2.038rem] bg-tertiary-100 rounded-full flex justify-center items-center `}>
            {name && <img src={name ? `/icons/${name}.svg` : src} className={`${className} `} alt={"icon"}/>}
        </div>

    )
}